import { get, put } from "../client";
import { GET_REVIEWS_MANAGE, GET_REVIEWS_STATS, TOGGLE_HIDE_REVIEW } from "../routes";

const REVIEWS = {
  getAll: (page = 1) => get(`${GET_REVIEWS_MANAGE}?page=${page}`),
  getStats: () => get(GET_REVIEWS_STATS),
  toggleHide: (id) => put(TOGGLE_HIDE_REVIEW(id), {}),
};

export default REVIEWS;
